<template>
    <div class="brand-container pt-3 mx-auto">
                <div class="col-md col pt-4 container-body"  v-if="isCreate">
                    <section>
                        <div class="pt-2">
                            <div class="h4 pb-2 text-uppercase" >
                              Add brand
                            </div>
                            <div class="brand-container border p-5 pt-5 pl-3">
                                <div class="row">
                                    <div class="col">
                                        <label class="col-md col"> New brand </label>
                                    </div>
                                    <div class="col">
                                        <input class="form-group border-bottom default-input col-md col" v-model="addBrands.brand_name" 
                                        placeholder="Enter the name" 
                                        v-on:keyup="getCreatevalid($event,'brand_name')">
                                        <div class="text-danger" v-if="!brand_validation_status_name">enter valid brand name</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class=" col">
                                        <label class="col-md col"> Brand Description </label>                                        
                                    </div>
                                    <div class="col">                                        
                                        <textarea v-model="addBrands.brand_description"  v-on:keyup="getCreatevalid($event,'brandDescription')"  maxlength="700" class="w-100"></textarea>
                                        <div class="text-danger text-lowercase small" v-if="!brand_validation_status_description">Desctiption is missing</div>
                                    </div>  
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <label class="col-md col"> Brand Image </label>                                        
                                    </div>
                                    <div class="col">
                                        <img  :src="brand_url" class="w-100 brand-bg-image" />
                                        <input type="file" @change="onBrandFileChange($event);getCreatevalid($event,'brandimage')" class="w-100" accept=".png, .jpg, .jpeg"/>
                                        <div class="text-danger text-lowercase small p-2" v-if="!brand_image_validation_status">Brand Image is missing</div>
                                    </div>  
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <label class="col-md col"> Brand URL</label>
                                    </div>
                                    <div class="col">
                                        <input class="form-group border-bottom default-input col-md col" v-model="addBrands.brand_url" 
                                        placeholder="Enter the  brand url" 
                                        v-on:keyup="getCreatevalid($event,'brand_url')">
                                        <div class="text-danger" v-if="brand_url_validation_status">enter valid brand url</div>
                                    </div>
                                </div>
                                
                            </div>  
                        </div>
                    </section>
                      <div class="p-4 text-center row">
                            <div class="col-md col text-right">
                                <button type="button" class="btn btn-default text-right back-button" @click="isCreate=false">
                                        <img class="add-image" src="@/assets/Back.png">
                                </button>
                            </div>
                            <div class="col-md col text-left">
                                <button type="button"  class="btn btn-primary" @click="isValidBrand()">ADD</button>
                            </div>
                    </div>
                    <span id="add-product-pop-over" data-toggle="modal" data-target="#isAddBrand"></span>
                    <div class="modal fade" id="isAddBrand" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    <h4 class="modal-title">Add new Brands</h4>
                                </div>
                                <div class="modal-body">
                                    <p class="body-text"> Do you confirm to add the Brand?</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default border"  data-dismiss="modal">No</button>
                                    <button type="button" class="btn btn-primary" @click="createBrands()" data-dismiss="modal">YES</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md col container-body"  v-if="!isCreate">
                    <section>                    
                        <div class="template-body tab-bg pt-3">
                            <div class="row">
                                <div class=" h4 col-7 col-md-7 pt-3 pb-4 text-uppercase" >
                                    Brands
                                </div>
                                <div class=" col-5 col-md-5 pt-2 pb-2 text-uppercase text-right " >
                                    <button type="button" class="btn btn-default text-left text-uppercase font-weight-bold add-button" @click="isCreate=true">
                                        <fa-icon :icon="['fas','plus']"/> Add new 
                                    </button>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table  class="table border pt-5 text-uppercase">
                                <tbody  >
                                    <tr>
                                    <th>S NO</th>
                                    <th>Brands</th>
                                    <th>edit</th>
                                    <!-- <th>Delete</th> -->
                                    <th>status</th>
                                    </tr>
                                </tbody>
                                <tbody >
                                    <tr  v-for="(brand,index) in brandsList" :key="index">
                                    <td> <span  class="">{{index+1}} </span></td>
                                    <td><span  class="">{{brand.brand_name}}</span></td>
                                    <td>
                                        <button type="button" class="btn btn-default" data-toggle="modal" data-target="#isUpdateBrand"
                                            @click="selected_brand_id=brand.brand_id,selected_brand_name=brand.brand_name,selected_brand_description=brand.brand_desc,update_brand_image=brand.brand_image,updated_brand_url=brand.brand_url">
                                            <span class="glyphicon glyphicon-plus" >
                                                <fa-icon :icon="['fas','pencil-alt']"/> 
                                            </span>
                                        </button>
                                    </td>
                                    <!-- <td>
                                        <button type="button" class="btn btn-default"
                                            @click="isDeleteBrand(brand.brand_id)">
                                            <span class="glyphicon glyphicon-plus" >
                                                <fa-icon :icon="['fas','trash-alt']"/> 
                                            </span>
                                        </button>
                                    </td> -->
                                    <td>
                                            <toggle-button v-model="brand.status" :value="brand.status" class=" pt-1"
                                            :color ="{checked: '#007bff', unchecked: '#858585'}"
                                            @change="updateBrandActive(brand.brand_id,brand.status)"/>
                                    </td>
                                    </tr>
                                
                                    </tbody>
                                </table>
                            </div>
                        </div>               
                    </section>
                </div> 

                <!-- info: modal for Edit brand name -->
                <div class="modal fade" id="isUpdateBrand" role="dialog">
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                                <h4 class="modal-title">Edit Brand</h4>
                            </div>
                            <div class="modal-body">
                                <div class="col">
                                    <input class="form-group border-bottom default-input col-md col" v-model="selected_brand_name" 
                                    v-on:keyup="getvalid($event,'brand_name')" placeholder="brand name">
                                    <div class="text-danger" v-if="!update_brand_name_status">enter valid brand name</div>
                                </div>         
                                <div class="col">
                                    <input class="form-group border-bottom default-input col-md col" v-model="selected_brand_description" 
                                    v-on:keyup="getvalid($event,'brandDescription')"  maxlength="700" 
                                     placeholder="description">
                                    <div class="text-danger" v-if="!update_brand_description_status">enter valid brand Description</div>
                                </div> 

                                <div class="col">
                                    <input class="form-group border-bottom default-input col-md col" v-model="updated_brand_url" 
                                    v-on:keyup="getvalid($event,'brandUrl')"  maxlength="700" 
                                     placeholder="brand url">
                                    <div class="text-danger" v-if="!update_brand_image_url">enter valid brand Url</div>
                                </div>
                                     
                                <div class="col p-2 pl-3">
                                    <img :src="update_brand_url" class="w-100 p-2 brand-bg-image" />
                                    <input type="file" ref="input_id" @change="onupdateBrandFileChange($event);getvalid($event,'brandimage')" class="w-100 p-2" accept=".png, .jpg, .jpeg" value=""/>
                                    <div class="text-danger text-lowercase small p-2" v-if="!update_brand_image_status">Brand Image is missing</div>
                                </div>  
                                
                                 

                            </div>
                            <div class="modal-footer">
                                <button type="button" v-if="!isValidStatus"  class="btn btn-primary" @click="isValidUpdateBrand()">UPDATE</button>
                                <button v-if="isValidStatus" type="button" class="btn btn-primary" @click="isValidUpdateBrand()" data-dismiss="modal">UPDATE</button>                                
                            </div>
                        </div>
                    </div>
                </div>

               

                <span id="delete-brand-pop-over" data-toggle="modal" data-target="#isdeleteBrand"></span>
                  <div class="modal fade" id="isdeleteBrand" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    <h4 class="modal-title">Delete Brands</h4>
                                </div>
                                <div class="modal-body">
                                    <p class="body-text"> Do you confirm to Delete the Brand?</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default border"  data-dismiss="modal">No</button>
                                    <button type="button" class="btn btn-primary" @click="DeleteBrand()" data-dismiss="modal">YES</button>
                                </div>
                            </div>
                        </div>
                    </div>  
                <span id="update-product-pop-over" data-toggle="modal" data-target="#isupdateBrand"></span>
                    <div class="modal fade" id="isupdateBrand" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    <h4 class="modal-title">UpdateBrands</h4>
                                </div>
                                <div class="modal-body">
                                    <p class="body-text"> Do you confirm to update the Brand?</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default border"  data-dismiss="modal">No</button>
                                    <button type="button" class="btn btn-primary" @click="updateBrandName()" data-dismiss="modal">YES</button>
                                </div>
                            </div>
                        </div>
                    </div>
    </div>
</template>
<script src="vuelidate/dist/vuelidate.min.js"></script>
<script lang="ts">
    import Vue from 'vue'
    import * as $ from 'jquery';
    import VueToast from 'vue-toast-notification';
    import 'vue-toast-notification/dist/theme-default.css'; 
    import AddCategoriesService from '../../shared/services/addCategory.service'
    import ProductService from '../../shared/services/product.service'

    const addCategoriesService = new AddCategoriesService();
    const productService = new ProductService();

    Vue.use(VueToast)


    export default { 
    components : {
    },
         data()  {
            return {
                toast:Vue.$toast,
                productList:{},
                addBrands:{},
                brandsList:{},
                brand_name:'',
                brandStatus:Boolean,
                active_status:true,
                brand_validation_status_name:true,
                brand_validation_status_description:true,
                brand_image_validation_status:true,
                // brand_url_validation_status:true,

                update_brand_name_status:true,
                update_brand_description_status:true,
                update_brand_image_status:true,
                update_brand_image_url:true,

                brand_image_status:true,
                validation_status:true,
                brand_validation_status:true,

                sc_id:0,
                mc_id:0,
                isDeleteId:null,
                isCreate:false,
                selected_brand_id:0,
                selected_brand_name:'',
                selected_brand_description:'',
                selected_brand_url:'',
                brand_image:'',
                update_brand_image:'',
                update_brand_url:null,
                brand_url: null
            }
        },
        
        computed: {
            isComplete () {
                this.brand_image_validation_status = (this.addBrands.brand_image)?true:false
                    return (this.addBrands.brand_name && this.addBrands.brand_description && this.brand_image_validation_status)
            },
            isUpdateComplete () {
                this.update_brand_image_status = (this.brand_image || this.update_brand_image) ? true : false
                    return (this.selected_brand_name && this.selected_brand_description && this.update_brand_image_status)
            },
            isValidStatus(){
                if(this.update_brand_name_status && this.update_brand_description_status && this.update_brand_image_status && this.update_brand_image_url)
                    return true
                else return false
            }
        },
       
        methods: {   
            // createion validation
            isValidBrand(){
                if(this.isComplete ){
                    $('#add-product-pop-over').trigger('click')
                }
                else {
                    this.brand_validation_status_name= (this.addBrands.brand_name) ? true : false
                    this.brand_validation_status_description= (this.addBrands.brand_description) ? true : false
                    this.brand_image_validation_status = (this.addBrands.brand_image)?true:false
                    this.brand_url_validation_status = (this.addBrands.brand_url)?true:false
                }
            },

            // updationvalidation
            isValidUpdateBrand(){
                if(this.isUpdateComplete ){
                    $('#update-product-pop-over').trigger('click')
                }
                
                else {
                    this.update_brand_name_status= (this.selected_brand_name) ? true : false
                    this.update_brand_description_status= (this.addBrands.brand_description || this.selected_brand_description) ? true : false
                    this.update_brand_image_status = (this.update_brand_image || this.brand_image)?true:false    
                    this.update_brand_image_url = (this.updated_brand_url|| this.brand_url)?true:false                 
                }
            },  

            
            getvalid(event,item){
                let value = event.target.value
                if(item == 'brand_name'){
                    var re = new RegExp("^[ A-Za-z_@./#&+-]*$");
                    if (re.test(value)) {
                        this.update_brand_name_status=true
                    } else {
                        this.update_brand_name_status=false
                    }
                }
                else if(item == 'brandDescription'){
                    let value = event.target.value;
                    this.update_brand_description_status =(value) ? true : false
                }
                else if(item ==  'brandimage'){
                    let value = event.target.value;
                    this.brandimage = (event.target.value) ? true : false;
                    this.update_brand_image_status = (value) ? true : false
                }
                else if(item == 'brandUrl'){
                    let value = event.target.value;
                    this.update_brand_url =(value) ? true : false
                }
            },

            getCreatevalid(event,item){
                let value = event.target.value
                if(item == 'brand_name'){
                    var re = new RegExp("^[ A-Za-z_@./#&+-]*$");
                    if (re.test(value)) {
                        this.brand_validation_status_name=true
                    } else {
                        this.brand_validation_status_name=false
                    }
                }
                else if(item == 'brandDescription'){
                    let value = event.target.value;
                    this.brand_validation_status_description =(value) ? true : false
                }
                else if(item ==  'brandimage'){
                    let value = event.target.value;
                    this.addBrands.brandimage = (event.target.value) ? true : false;
                    this.brand_image_validation_status = (value) ? true : false
                }
                else if(item == 'brandUrl'){
                    let value = event.target.value;
                    this.update_brand_url=(value) ? true : false;
                    this.brand_image_validation_status = (value) ? true : false
                }
            },

            onBrandFileChange(e) {
                const file = e.target.files[0];
                this.addBrands.brand_image = e.target.files.item(0);
                this.brand_url = URL.createObjectURL(file);

            }, 

            onupdateBrandFileChange(e){
                const file = e.target.files[0];
                this.update_brand_image = e.target.files.item(0);
                this.update_brand_url = URL.createObjectURL(file)
            },
            createBrands(){
                let _brandsForm = new FormData()
                    Object.keys(this.addBrands).forEach((key) => {
                        _brandsForm.append(key, this.addBrands[key])
                    })
                addCategoriesService.createBrands(_brandsForm)
                .then(response => {
                    this.addBrands={};
                    this.toast.success("Brand is successfully added",{
                        position:'top-right'
                    })
                    this.getbrands();
                    this.isCreate=false;
                })
                .catch(e => {
                    this.toast.error("Error occured while adding",{
                        position:'top-right'
                    })  
                     this.errors.push(e)
                })

            },
            getbrands(){
                productService.getAdminBrands()
                    .then(response => {
                        this.brandsList = response.data.output.success[0].data ;
                    })
                    .catch(e => {
                    this.errors.push(e)
                    })
            },

            updateBrandActive(brand_id,activeFlag){
                // init
                let obj = {};

                obj['brand_id'] = brand_id;
                obj['status'] = (activeFlag)? 1 : 0;

                let activeStatusText = (activeFlag)? 'Active' : 'Inactive';
                
                productService.activeBrand(obj)
                .then(response => {
                this.productList = response.data.output.success[0].data;
                   this.getbrands(0,0);
                   this.toast.success("Brand is now " + activeStatusText,{
                        position:'top-right'
                    })
                    
                })
                .catch(e => {
                    this.toast.error("Brand or status is invalid",{
                        position:'bottom-right'
                    })  
                    this.errors.push(e)
                }) 
            },

            updateBrandName(){
                // init
                let obj = {};
                obj['brand_id'] = this.selected_brand_id;
                obj['brand_name'] = this.selected_brand_name;
                obj['brand_desc'] = this.selected_brand_description;
                obj['brand_url']  = this.updated_brand_url;

                if(this.update_brand_image == ''){
                    obj['brand_image'] = this.brand_image
                }
                else {
                    obj['brand_image'] = this.update_brand_image
                }
                let _brandsForm = new FormData()
                    Object.keys(obj).forEach((key) => {
                        _brandsForm.append(key, obj[key])
                    })                
                productService.updateBrand(_brandsForm)
                .then(response => {
                this.productList = response.data.output.success[0].data;
                   this.getbrands(0,0);
                   this.update_brand_url = null;
                   this.update_brand_image= '';
                   this.toast.success("Brand name is updated " ,{
                        position:'top-right'
                    })
                    this.brand_image = ''  
                    this.$refs.input_id.value='';                  
                    this.isCreate = false
                })
            },

            isDeleteBrand(id){
                $('#delete-brand-pop-over').trigger('click')
                this.isDeleteId = id
            },
            // DeleteBrand(){
            // }

        },
        
         created() {
                productService.getAdminBrands()
                .then(response => {
                    this.brandsList = response.data.output.success[0].data ;
                    const filteredItems  = this.brandsList;
                    filteredItems.forEach(element => {
                        element.status = element.status === 1 ? true : false;
                    });
                    const filteredBrands = filteredItems.filter((item)=> item.status === true );
                    const fitleredImages = filteredBrands.map((
                            { brand_image}) => ({ brand_image}));
                })
                .catch(e => {
                this.errors.push(e)
                })

         }
    }
</script>

<style  scoped>
  @import '../../style.css';

   .header-bg-image{
       height: 400px !important;
   }

   .table td, .table th {
        padding: .75rem;
        vertical-align: top;
        border: 1px solid #e5e5e5;
   }

   .closebtn {
        position: absolute;
        top: 0;
        right: 55px;
        font-size: 55px;
        margin-left: 50px;
        cursor: pointer;
    }
     .container-body{
        overflow-y: auto;
        overflow-x: hidden;
    }

    
    .logo{
        width:50%;
        margin-bottom: -20%;
    }

    input{
        line-height: 30px;
        border:0px;
    }
    input:active{
        border:0px;
        border-bottom: 1px solid grey;
    }
    .header-options{
        margin-left: auto;
    }   
    .container-header{
      margin-left: -15px;
    }
    th{
        text-align:center;
        font-family: 'Barlow', sans-serif;
    }
    td{
        text-align:center;
        font-family: 'Barlow', sans-serif;
    }
    .add-button{
        float: right;
        padding-right:1%;
    }
    .btn-disabled{
        color:#fff;
        background:lightgray;
        border-color:lightgray;
        cursor:not-allowed;
    }
    .btn-disabled:hover{
        color:#fff;
        background:lightgray;
        border-color:lightgray;
        cursor:not-allowed;
    }
    .container-body{
        padding-right: 0px;
    }
    .text-uppercase{
        font-family: 'Barlow', sans-serif;
    }
    .brand-container{
        font-family: 'Barlow', sans-serif;
    }
    .add-image{
        width:22px;
        background:transparent
    }
    table tbody+tbody {
        border-top: 0px solid #dee2e6;
    }
</style>